<script>
import SpellCheckedText from "@/components/SpellCheckedText.vue";
import PhotoBox from "@/components/PhotoBox.vue";
import { formatedDate2 } from "../../../utils/proposalValidation";

export default {
    name: "FPTemp7",
    components: {
        SpellCheckedText,
        PhotoBox
    },
    props: ["proposal"],
    data() {
        return {
            footerImage: ""
        };
    },
    computed: {
        project() {
            return this.proposal.projects && this.proposal.projects.length > 0
                ? this.proposal.projects[0]
                : null;
        }
    },
    mounted() {
        this.generateGradients();
    },
    methods: {
        formatedDate2,
        generateGradients() {
            const fCanvas = document.createElement('canvas');
            fCanvas.width = 672;
            fCanvas.height = 400;
            const fCtx = fCanvas.getContext('2d');
            const fGrad = fCtx.createLinearGradient(0, 400, 0, 0);
            fGrad.addColorStop(0, 'rgba(0, 0, 0, 0.8)');
            fGrad.addColorStop(1, 'rgba(0, 0, 0, 0)');
            fCtx.fillStyle = fGrad;
            fCtx.fillRect(0, 0, 800, 400);
            this.footerImage = fCanvas.toDataURL();
        }
    }
};
</script>

<template>
    <div class="main-container" :style="{
        '--header-color': proposal && proposal.style && proposal.style.colorScheme && proposal.style.colorScheme.header,
        '--body-color': proposal && proposal.style && proposal.style.colorScheme && proposal.style.colorScheme.body,
        '--footer-color': proposal && proposal.style && proposal.style.colorScheme && proposal.style.colorScheme.footer,
        '--heading-color': proposal.style.heading.color,
        '--heading-size': proposal.style.heading.size + 'px',
        '--heading-font': proposal.style.heading.font,
        '--heading-bold': proposal.style.heading.bold ? 700 : 400,
        '--heading-italic': proposal.style.heading.italic ? 'italic' : 'normal',
        '--heading-underline': proposal.style.heading.underline ? 'underline' : 'none',
        '--label-color': proposal.style.label.color,
        '--label-size': proposal.style.label.size + 'px',
        '--label-font': proposal.style.label.font,
        '--label-bold': proposal.style.label.bold ? 700 : 400,
        '--label-italic': proposal.style.label.italic ? 'italic' : 'normal',
        '--label-underline': proposal.style.label.underline ? 'underline' : 'none',
        '--text-color': proposal.style.text.color,
        '--text-size': proposal.style.text.size + 'px',
        '--text-font': proposal.style.text.font,
        '--text-bold': proposal.style.text.bold ? 700 : 400,
        '--text-italic': proposal.style.text.italic ? 'italic' : 'normal',
        '--text-underline': proposal.style.text.underline ? 'underline' : 'none',
    }">
        <div class="frontPage">
            <div class="photo-pane">
                <PhotoBox v-if="project" class="photobox" :project="project"
                    :bgColor="proposal && proposal.style && proposal.style.colorScheme && proposal.style.colorScheme.header" />

                <div v-if="project && footerImage" class="bottom-gradient">
                    <img :src="footerImage" class="w-full h-full" />
                </div>

                <div class="logo-overlay photobox">
                    <PhotoBox :project="proposal" type="logo" objectFit="contain" bgColor="transparent" />
                </div>

                <div class="project-name-overlay" v-if="project">
                    <SpellCheckedText :value="proposal.name || ''" @input="val => proposal.name = val" />
                </div>
            </div>

            <!-- Right Pane (Detailed Info) -->
            <div class="info-pane">
                <div class="info-content">
                    <!-- Proposal for -->
                    <div class="info-section">
                        <label class="section-label min-width">Proposal for:</label>
                        <div class="section-details">
                            <h1 class="label">
                                <SpellCheckedText :value="proposal.name || ''" @input="val => proposal.name = val" />
                            </h1>
                            <p class="text">
                                {{ formatedDate2(proposal.submissionDate) }}
                            </p>
                        </div>
                    </div>

                    <!-- Prepared for / Attn -->
                    <div class="info-section" v-if="proposal.projects.length > 0">
                        <label class="section-label min-width">Prepared for:</label>
                        <div class="section-details">
                            <h2 class="label">
                                <SpellCheckedText :value="proposal.clientAccountName || ''"
                                    @input="val => proposal.clientAccountName = val" />
                            </h2>
                        </div>
                    </div>

                    <div class="info-section" v-if="proposal.projects.length > 0">
                        <label class="section-label min-width">Attn:</label>
                        <div class="section-details">
                            <h2 class="text">
                                <SpellCheckedText
                                    :value="proposal.primaryClientAccountContactName || ''"
                                    @input="val => proposal.primaryClientAccountContactName= val" />
                                <span>{{ proposal.primaryClientAccountContactName? ', ' : '' }}</span>
                                <!--SpellCheckedText
                                    :value="proposal.primaryClientAccountContactName || ''"
                                    @input="val => proposal.primaryClientAccountContactName = val" /-->
                            </h2>
                        </div>
                    </div>

                    <!-- Submitted by -->
                    <div class="info-section text-left">
                        <label class="section-label submitted">Submitted by:</label>
                        <div class="section-details">
                            <h2 class="label">
                                <SpellCheckedText :value="proposal.submittedBy || ''"
                                    @input="val => proposal.submittedBy = val" />
                            </h2>
                            <div class="company-details">
                                <p v-if="proposal.compAddress">
                                    <SpellCheckedText :value="proposal.compAddress || ''"
                                        @input="val => proposal.compAddress = val" />
                                </p>
                                <p v-if="proposal.compCity || proposal.compStateProvince">
                                    <SpellCheckedText :value="proposal.compCity || ''"
                                        @input="val => proposal.compCity = val" />
                                    <span>{{ proposal.compCity ? ', ' : '' }}</span>
                                    <SpellCheckedText :value="proposal.compStateProvince || ''"
                                        @input="val => proposal.compStateProvince = val" />
                                </p>
                                <p v-if="proposal.compContactNo">
                                    <SpellCheckedText :value="proposal.compContactNo || ''"
                                        @input="val => proposal.compContactNo = val" />
                                </p>
                                <p v-if="proposal.compEmail">
                                    <SpellCheckedText :value="proposal.compEmail || ''"
                                        @input="val => proposal.compEmail = val" />
                                </p>
                                <p v-if="proposal.compWebsite">
                                    <SpellCheckedText :value="proposal.compWebsite || ''"
                                        @input="val => proposal.compWebsite = val" />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.main-container {
    display: block;
    width: 296.83mm;
    height: 211mm;
    min-height: 211mm;
    position: relative;
    box-sizing: border-box;
    background: white;
    overflow: hidden;

    &:hover {
        .photobox :deep(.photo-overlay) {
            opacity: 1;
        }

        .photobox :deep(img) {
            opacity: 0.9;
        }
    }

    .frontPage {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 100%;

        .photo-pane {
            position: relative;
            width: 60%;
            background: var(--header-color);

            .logo-overlay {
                position: absolute;
                top: 30px;
                left: 30px;
                width: 180px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 10;
            }

            .bottom-gradient {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 150px;
                z-index: 2;
                pointer-events: none;
            }

            .project-name-overlay {
                position: absolute;
                bottom: 30px;
                left: 30px;
                color: var(--body-color);
                font-size: 10px;
                font-weight: 700;
                letter-spacing: 1px;
                z-index: 50;
            }
        }

        .info-pane {
            display: flex;
            width: 40%;
            flex-direction: column;
            justify-content: center;
            background: var(--footer-color);
            padding: 15px;

            .info-content {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .info-section {
                    display: flex;
                    flex-direction: row;

                    &:first-child {
                        margin-bottom: 30px;
                    }

                    .section-label {
                        display: block;
                        color: var(--heading-color);
                        font-size: var(--heading-size);
                        font-family: var(--heading-font);
                        font-weight: var(--heading-bold);
                        font-style: var(--heading-italic);
                        text-decoration: var(--heading-underline);
                        margin: 0;
                        white-space: nowrap;
                        margin-right: 20px;

                        &.min-width {
                            min-width: calc(var(--heading-size) * 6.6);
                        }
                    }

                    .section-details {
                        display: flex;
                        flex-direction: column;

                        .label {
                            color: var(--label-color);
                            font-size: var(--label-size);
                            font-family: var(--label-font);
                            font-weight: var(--label-bold);
                            font-style: var(--label-italic);
                            text-decoration: var(--label-underline);
                            line-height: 1;
                            margin: 0;
                        }

                        .text {
                            color: var(--text-color);
                            font-size: var(--text-size);
                            font-family: var(--text-font);
                            font-weight: var(--text-bold);
                            font-style: var(--text-italic);
                            text-decoration: var(--text-underline);
                            margin: 0;
                        }

                        .company-details {
                            display: flex;
                            flex-direction: column;
                            gap: 5px;
                            margin-top: 10px;

                            p {
                                color: var(--text-color);
                                font-size: var(--text-size);
                                font-family: var(--text-font);
                                font-weight: var(--text-bold);
                                font-style: var(--text-italic);
                                text-decoration: var(--text-underline);
                                margin: 0;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
